export default "__VITE_ASSET__ChYhEHXr__"